import React from 'react';
import { Routes, Route } from 'react-router-dom';
import AnalysisReporting from './pages/AnalysisReporting/AnalysisReporting';
import DeviceComparison from './pages/AnalysisReporting/DeviceComparison';
import AssignDashboard from './pages/Dashboard/AssignDashboard';
import CreateDashboard from './pages/Dashboard/CreateDashboard';
import Dashboard from './pages/Dashboard/Dashboard';
import DashboardLayout from './pages/Dashboard/DashboardLayout';
import DashboardList from './pages/Dashboard/DashboardList';
import DashboardListView from './pages/Dashboard/DashboardListView';
import DashboardTwo from './pages/Dashboard/DashboardTwo';
import DeviceInformation from './pages/Dashboard/DeviceInformation';
import AddDevice from './pages/Devices/AddDevice';
import DeviceData from './pages/Devices/DeviceData';
import DeviceTypes from './pages/Devices/DeviceTypes';
import EditDevice from './pages/Devices/EditDevice';
import AlarmSummary from './pages/Notifications/AlarmSummary';
import AlarmView from './pages/Notifications/AlarmView';
import CreateAlarm from './pages/Notifications/CreateAlarm';
import EditAlarm from './pages/Notifications/EditAlarm';
import RecipientList from './pages/Notifications/RecipientList';
import EditProfile from './pages/Profile/EditProfile';
import Profile from './pages/Profile/Profile';
import DashboardSettings from './pages/Settings/DashboardSettings';
import ElectricityTariff from './pages/Settings/ElectricityTariff';
import ManageFormulas from './pages/Settings/Formula/ManageFormulas';
import Parameters from './pages/Settings/Parameters/Parameters';
import Settings from './pages/Settings/Settings';
import AddSiteLocation from './pages/SiteLocations/AddSiteLocation';
import EditSiteLocation from './pages/SiteLocations/EditSiteLocation';
import SiteDocuments from './pages/SiteLocations/SiteDocuments';
import SiteLocationView from './pages/SiteLocations/SiteLocationView';
import UserCreate from './pages/Users/UserCreate';
import UserDetails from './pages/Users/UserDetails';
import UserEdit from './pages/Users/UserEdit';
import SiteLocationsList from './pages/SiteLocations/SiteLocationsList';
import UserList from './pages/Users/UserList';
import BuildingBackgroundTypes from './pages/Settings/BuildingTypes/BuildingBackgroundTypes';
import DeviceList from './pages/Devices/DeviceList';
import DeviceDetails from './pages/Devices/DeviceDetails';
import AlarmHistory from './pages/Notifications/AlarmHistory';
import DeviceCSVUpload from './pages/Devices/DeviceCSVUpload';
import EditDashboard from './pages/Dashboard/EditDashboard';
import Dial from './pages/Dial/Dial';
import DialView from './pages/Dial/DialView';
import CreateDial from './pages/Dial/CreateDial';
import EditDial from './pages/Dial/EditDial';

export default function MyRoutes({ handle }) {
  return (
    <Routes>
      {/* Dashboard Informations Route */}
      <Route path="/dashboardList/:id" element={<DashboardListView />} />
      <Route path="/dashboardEdit/:id" element={<EditDashboard />} />
      <Route path="/newDashboard" element={<CreateDashboard />} />
      <Route path="/dashboardList" element={<DashboardList />} />
      <Route path="/assignDashboard" element={<AssignDashboard />} />
      <Route path="/liveDashbroad" element={<DashboardLayout />} />
      <Route path="/2" element={<DashboardTwo handle={handle} />} />
      <Route path="/" element={<Dashboard />} />

      {/* users route */}
      <Route path="/users" element={<UserList />} />
      <Route path="/users/create" element={<UserCreate />} />
      <Route path="/users/edit/:userId" element={<UserEdit />} />
      <Route path="/users/details/:userId" element={<UserDetails />} />

      {/* Device Informations Route */}
      <Route path="/device-details" element={<DeviceInformation />} />

      <Route path="site-locations" element={<SiteLocationsList />} />
      <Route path="site-locations/create" element={<AddSiteLocation />} />
      <Route path="site-locations/details/:siteLocationId" element={<SiteLocationView />} />
      <Route path="site-locations/edit/:siteLocationId" element={<EditSiteLocation />} />
      <Route path="site-locations/document/:siteLocationId" element={<SiteDocuments />} />

      {/* Device related routes */}

      <Route path="devices" element={<DeviceList />} />
      <Route path="add-devices" element={<AddDevice />} />
      <Route path="device-csv-upload" element={<DeviceCSVUpload />} />
      <Route path="device-types" element={<DeviceTypes />} />
      <Route path="devices/details/:deviceId" element={<DeviceDetails />} />
      <Route path="devices/edit/:deviceId" element={<EditDevice />} />
      <Route path="devices/data/:deviceId" element={<DeviceData />} />

      {/* Analysis &Reporting related routes */}
      <Route path="/parameter-comparison" element={<AnalysisReporting />} />
      <Route path="/device-comparison" element={<DeviceComparison />} />

      {/* Settings related Routes */}
      <Route path="/settings" element={<Settings />} />
      <Route path="/building-background-types" element={<BuildingBackgroundTypes />} />
      <Route path="/electricity-tariff" element={<ElectricityTariff />} />
      <Route path="/dashboard-settings" element={<DashboardSettings />} />
      <Route path="/parameters" element={<Parameters />} />
      <Route path="/formulas" element={<ManageFormulas />} />

      {/* Notification related routes */}
      <Route path="/alarm-summary" element={<AlarmSummary />} />
      <Route path="/alarm-history" element={<AlarmHistory />} />
      <Route path="/create-alarm" element={<CreateAlarm />} />
      <Route path="/recipient-list" element={<RecipientList />} />
      <Route path="/alarm-view/:alarmId" element={<AlarmView />} />
      <Route path="/edit-alarm/:alarmId" element={<EditAlarm />} />

      <Route path="/profile" element={<Profile />} />
      <Route path="/edit-profile" element={<EditProfile />} />

      {/* dial */}
      <Route path="/dial" element={<Dial />} />
      <Route path="/dial/create" element={<CreateDial />} />
      <Route path="/dial/edit/:id" element={<EditDial />} />
      <Route path="/dial/:id" element={<DialView />} />
    </Routes>
  );
}
